import 'masonry-layout';

import Log from '~/_Utility/Log';

class Masonry {

    /**
     * @since 2.0.0
     * @method constructor
     */
    constructor() {
        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 2.0.0
     * @return void
     */
    init() {
        // Probably listen for the masonry thing here
        new Log('Masonry initialized.', 'init');
    }
}

export default Masonry;